import Api from '@/services/Api'

// Nacrt knjizenja stavki bankovnog izvoda prema knjizenjima prijasnjih izvoda.
export default {

  // Samo citanje: {CompanyId, MainLedgerId} -> {izvod, stavke, sazetak, konta, ...}
  prijedlog (query) {
    return Api().get('knjizenje/izvod/prijedlog', {params: query})
  },

  // Partner na neproknjizenu stavku izvoda: {CompanyId, MainLedgerId, sideId, partnerId?, partnerVATID?}
  dodijeliPartnera (podaci) {
    return Api().post('knjizenje/izvod/partner', podaci)
  },

  // Tek ovdje se pisu stvarni retci: {CompanyId, MainLedgerId, stavke: [{sideId, konto}]}
  potvrdi (podaci) {
    return Api().post('knjizenje/izvod/potvrdi', podaci)
  }
}
